import React, { ReactNode } from 'react';

import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';

import './cve.css';

type Props = {
  title?: ReactNode;
  children?: ReactNode;
  contentStyle?: React.CSSProperties;
};
const CveCard = ({ children, contentStyle, title }: Props) => {
  return (
    <IBCard
      isCovered
      style={{ ...contentStyle, marginBottom: '16px' }}
      title={title}
    >
      {children}
    </IBCard>
  );
};

export default CveCard;
